import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {take} from 'rxjs/operators';
import {Router} from '@angular/router';
import {CommandService} from '@core/services/command.service';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {GridValueChangeEvent} from '@shared/models/common.models';
import {DialogModel} from '@shared/models/dialog.model';
import {DialogService} from '@shared/services/dialog-service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {PlatformQueryService} from '@core/services/platform-query.service';
import {PlatformQuery} from '@shared/models/platform-query/platform-query';
import {Api} from '@shared/constants/common-field.constants';
import {FileSelectorModel} from '@features/file-manager/models/file-selector.model';
import {IconViewModel} from '@features/file-manager/models/file-manager.model';
import {SetCurrentRightSideComponentAction} from '@shared/components/platform-sidebar/store/platform-sidebar.action';
import {Store} from '@ngrx/store';
import {PlatformSidebarState} from '@shared/components/platform-sidebar/store/platform-sidebar.reducer';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {QueryProvider} from '@shared/queries/query-provider';

@Injectable({
  providedIn: 'root',
})
export class PlatformToolDataMappingHandler implements IPlatformToolHandler {
  magicLinkModel: MagicLinkModel;
  invalidateSubject = new InvalidateSubject();
  magicLinkModelValueChanged = new EventEmitter<any>();
  selectedTabModel: TabModel;

  constructor(
    private router: Router,
    private commandService: CommandService,
    private platformQueryService: PlatformQueryService,
    private dialogService: DialogService,
    private snackBarService: SnackBarService,
    private platformSidebarStore: Store<PlatformSidebarState>,
    private fuseSplashScreenService: FuseSplashScreenService,
    private queryStore: Store<IQueryState>
  ) {
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand) {
    switch (command.name) {
      case 'WorkflowCleanupCommand':
        this.handleWorkflowCleanUpCommand(command);
        return;
    }
    this.executeCommandToApi(command);
  }

  setSelectedTab(selectedTab: TabModel): void {
    this.selectedTabModel = selectedTab;
    if (selectedTab.tabData?.DetailsHelpId &&
      ((!this.magicLinkModel.fieldValues.hasOwnProperty('FlowId')  || this.magicLinkModel.fieldValues.FlowId == null) && (!this.magicLinkModel.fieldValues.hasOwnProperty('NodeId')  || this.magicLinkModel.fieldValues.NodeId == null)))  {
      // ! [MAGIC-BAR-AUTO-OPEN]
      this.platformSidebarStore.dispatch(
        new SetCurrentRightSideComponentAction(
          {component: 'HelpNotesComponent', data: {isUserAction: false}, componentInfo: {id: 'HelpNotesComponent'}}));
    }
    this.invokeReferenceOptionsQuery();
  }

  valueChanged($event: GridValueChangeEvent) {
    console.log('[Event]', $event);
    if ($event.action) {
      this.handleActions($event);
    } else if ($event.fieldDefinition) {
      if (this.magicLinkModel.additionalCommands[$event.fieldDefinition.key]) {
        const command = this.magicLinkModel.additionalCommands[
          $event.fieldDefinition.key
          ];
        command.fieldValues['ItemId'] = $event.item.id;
        this.executeCommandToApi(command);
        return;
      }
      switch ($event.fieldDefinition.key) {
        case 'Destination':
          this.handleTargetMapping($event);
          break;
        case 'Source':
          this.handleTargetMapping($event);
          break;
        case 'Match': {
          const command = this.magicLinkModel.additionalCommands[
            'UpdateFieldMappingCommand'
            ] as PlatformCommand;
          command.fieldValues['DataMappingFieldItemId'] = $event.item.id;
          command.fieldValues['UpdatedProperty'] = 'DataMappingFieldItem';
          command.fieldValues['SelectedItem'] = $event['selectedItem'];
          this.executeCommandToApi(command);
        }
          break;
        case 'ValueMappings':
          $event.item.cells['ValueMappingId'].value !== null && $event.item.cells['ValueMappingId'].value !== ""
            ? this.navigateToItem($event)
            : this.updateDataMappingField($event);
          break;
        case 'Reference':
          const command = this.magicLinkModel.additionalCommands[
            'UpdateReferenceFieldCommand'
            ] as PlatformCommand;
          command.fieldValues['SourceFieldItemId'] = $event.item?.id;
          command.fieldValues['ReferenceFieldItemId'] = $event.item?.cells[$event.fieldDefinition.key]?.value;
          command.fieldValues['RemoveReference'] = $event.item?.cells[$event.fieldDefinition.key]?.value === '';
          this.executeCommandToApi(command);
          break;
        default:
          this.openDataMappingItem($event);
          break;
      }
    }
  }
  private invokeReferenceOptionsQuery() {
    this.invalidateReferenceOptions();
  }
  private invalidateReferenceOptions() {
    const referenceOptionsQueryKey = this.magicLinkModel?.fieldValues['ReferenceOptionsQueryKey'];
    if (referenceOptionsQueryKey) {
      QueryProvider.invokeQuery(this.queryStore, referenceOptionsQueryKey, {});
    }
  }
  selectionChanged($event: any) {
    if ($event['ColumnHeaderButtonText']) {
      this.handleCustomHeaderButtonClick($event);
    }
  }

  private navigateToItem($event: GridValueChangeEvent) {
    const canFactorized = $event.item.cells['CanFactorized'].value;
    const canValueMapped = $event.item.cells['CanValueMapped'].value;
    const valueMappingId = $event.item.cells['ValueMappingId'].value;
    if (canFactorized) {
      const command = this.magicLinkModel.additionalCommands["CanFactorized"];
      if (!command) {
        return;
      }
      command.fieldValues['ShouldUpdate'] = true;
      command.fieldValues['MappingModule'] = 'GrowthAssumptionDetails';
      command.fieldValues['ItemId'] = valueMappingId;
      command.fieldValues['FieldKey'] = 'GrowthAssumption';
      this.executeCommandToApi(command);
      return;
    }
    if (canValueMapped) {
      const command = this.magicLinkModel.additionalCommands["CanValueMapped"];
      if (!command) {
        return;
      }
      command.fieldValues['ItemId'] = valueMappingId;
      command.fieldValues['FieldKey'] = 'MappingName';
      this.executeCommandToApi(command);
      return;
    }
  }

  private updateDataMappingField($event: GridValueChangeEvent) {
    const updateDataMappingFieldCommand = new PlatformCommand(
      'UpdateDataMappingFieldItemCommand',
      Api.FileStoreApi
    );
    updateDataMappingFieldCommand.title = 'Update Value Mappings';
    updateDataMappingFieldCommand.fieldValues['DataMappingFieldItemId'] =
      $event.item.id;
    updateDataMappingFieldCommand.fieldValues['DataMappingItemId'] =
      $event.item.cells['DataMappingItemId'].value;
    updateDataMappingFieldCommand.fieldValues['DestinationDataType'] =
      $event.item.cells['DestinationDataType'].value;
    updateDataMappingFieldCommand.fieldValues['Destination'] =
      $event.item.cells['Destination'].value;
    updateDataMappingFieldCommand.fieldValues['Source'] =
      $event.item.cells['Source'].value;
    updateDataMappingFieldCommand.fieldValues['SourceDataType'] =
      $event.item.cells['SourceDataType'].value;
    updateDataMappingFieldCommand.fieldValues['SourceFieldDataType'] =
      $event.item.cells['SourceFieldDataType'].value;
    updateDataMappingFieldCommand.fieldValues['UpdateValueMappings'] = true;
    updateDataMappingFieldCommand.fieldValues['CanValueMapped'] =
      $event.item.cells['CanValueMapped'].value;
    updateDataMappingFieldCommand.fieldValues['CanFactorized'] =
      $event.item.cells['CanFactorized'].value;
    this.executeCommandToApi(updateDataMappingFieldCommand);
  }

  private handleTargetMapping($event: GridValueChangeEvent) {
    if ($event.isRemove) {
      this.executeRemoveField($event);
    } else if ($event.isNewField) {
      this.mapToNewField($event);
    } else {
      this.mapToExistingField($event);
    }
  }

  private handleCustomHeaderButtonClick($event: any) {
    const type = $event['SourceSelectorType'];
    switch (type) {
      case 'SOURCE':
        console.log('[SOURCE]');
        if (!$event[$event.ColumnHeaderButtonDisableKey]) {
          this.openSourceOrDestinationSelector(type, 'Source');
        } else {
          this.navigateToFieldMapping(type);
        }
        break;
      case 'DESTINATION':
        console.log('[DESTINATION]');
        if (!$event[$event.ColumnHeaderButtonDisableKey]) {
          this.openSourceOrDestinationSelector(type, 'Destination');
        } else {
          this.navigateToFieldMapping(type);
        }
        break;
    }
  }

  private handleActions($event: GridValueChangeEvent) {
    if (this.magicLinkModel.additionalCommands[$event.action.id]) {
      this.handleFromAdditionalCommands($event);
      return;
    }
    switch ($event.action.id) {
      case 'Open':
        this.openDataMappingItem($event);
        break;
      case 'Delete':
        this.deleteDataMappingItem($event);
        break;
      case 'DeleteValueMapping':
        this.deleteValueMapping($event);
        break;
      case 'RemoveValueMapping':
        this.removeValueMapping($event);
        break;
      case 'Edit':
        this.openEditor($event);
        break;
    }
  }

  private handleFromAdditionalCommands($event: GridValueChangeEvent) {
    switch ($event.action.id) {
      case 'Delete':
        this.dialogService
          .showYesNoDialog(
            'Confirm Delete',
            'Are you sure you want to delete this field mapping?'
          )
          .pipe(take(1))
          .subscribe((state) => {
            if (state && state.action === 'OK') {
              const deleteCommand = this.magicLinkModel.additionalCommands[$event.action.id];
              deleteCommand.fieldValues['ItemId'] = $event.item.id;
              deleteCommand.fieldValues['IsDestinationToSource'] = $event.fieldSection['id'] == 'toggledatamappingfielditem' ? true : false;
              this.executeCommandToApi(deleteCommand);
              this.resetPlatformCommandFieldValues(deleteCommand, ['ItemId']);
            }
          });
        break;
      default:
        const command = this.magicLinkModel.additionalCommands[$event.action.id];
        command.fieldValues['ItemId'] = $event.item.id;
        this.executeCommandToApi(command);
        break;
    }
  }

  private removeValueMapping($event: GridValueChangeEvent) {
    this.dialogService
      .showYesNoDialog(
        'Confirm Remove',
        'Are you sure you want to remove this value mapping or growth assumption?'
      )
      .pipe(take(1))
      .subscribe((state) => {
        if (state && state.action === 'OK') {
          const deleteValueMappingCommand = new PlatformCommand(
            'DeleteValueMappingCommand',
            Api.FileStoreApi
          );
          deleteValueMappingCommand.fieldValues['DataMappingFieldItemId'] =
            $event.item.id;
          deleteValueMappingCommand.fieldValues['RemoveValueMapping'] = true;
          this.executeCommandToApi(deleteValueMappingCommand);
          this.resetPlatformCommandFieldValues(deleteValueMappingCommand, [
            'ItemId',
            'DataMappingFieldItemId',
            'RemoveValueMapping',
          ]);
        }
      });
  }

  private deleteValueMapping($event: GridValueChangeEvent) {
    const deleteValueMappingCommand = new PlatformCommand(
      'DeleteValueMappingCommand',
      Api.FileStoreApi
    );
    deleteValueMappingCommand.fieldValues['ItemId'] = $event.item.id;
    deleteValueMappingCommand.fieldValues['DataMappingFieldItemId'] =
      $event.item.cells['DataMappingFieldItemId'].value;
    this.executeCommandToApi(deleteValueMappingCommand);
  }

  private deleteDataMappingItem($event: GridValueChangeEvent) {
    const deleteCommand = this.magicLinkModel.additionalCommands['Delete'];
    deleteCommand.fieldValues['DataMappingItemId'] = $event.item.id;
    this.executeCommandToApi(deleteCommand);
  }

  private openDataMappingItem($event: GridValueChangeEvent) {
    const openCommand = this.magicLinkModel.additionalCommands['Open'];
    openCommand.fieldValues['DataMappingItemName'] =
      $event.item.cells.Name.displayText;
    openCommand.fieldValues['DataMappingItemId'] = $event.item.id;
    openCommand.fieldValues['ShouldUpdate'] = true;
    this.executeCommandToApi(openCommand);
  }

  private openSourceOrDestinationSelector(type: string, title: string) {
    const dataMappingItemId = this.magicLinkModel.tabBar.tabs[
      this.magicLinkModel.tabBar.selectedIndex
      ].tabData['DataMappingItemId'];
    const dialogModel = DialogModel.create(
      `Select ${title}`,
      'SelectDataMappingSourceDialogComponent',
      {
        type,
        dataMappingItemId,
        returns: 'single',
      },
      '400px',
      '400px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe((res) => {
      console.log(res);
      if (res && res.action === 'OK') {
        const command = this.magicLinkModel.additionalCommands[
          'CreateDataMappingFieldItems'
          ];
        command.fieldValues['SelectorType'] = res.data.input.type;
        if (res.data.input.selectedSource) {
          command.fieldValues['SelectedSource'] = res.data.input.selectedSource;
        }
        if (res.data.input.relativePath) {
          command.fieldValues['SelectedSourceRelativePath'] =
            res.data.input.relativePath;
          command.fieldValues['SelectedSourceFileName'] =
            res.data.input.fileName;
        }
        this.executeCommandToApi(command);
        this.resetPlatformCommandFieldValues(command, [
          'SelectedSource',
          'SelectorType',
          'SelectedSourceRelativePath',
          'SelectedSourceFileName',
        ]);
      }
    });
  }

  private executeCommandToApi(command: PlatformCommand) {
    console.log('[Executing PlatformCommand] -> ', command.name);
    command = JSON.parse(JSON.stringify(command));
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService
        .executePlatformCommand(command)
        .pipe(take(1))
        .subscribe(
          (res) => {
            console.log('Command Response', res);
            this.fuseSplashScreenService.hide();
            if (res.fieldValues['ShowWarning']) {
              this.snackBarService.showWarning(res.fieldValues['ShowWarning']);
            }
            if (res.fieldValues['SnackBarMessage']) {
              const duration = res.fieldValues['SnackBarMessage'].length * 80;
              this.snackBarService.showInformation(
                res.fieldValues['SnackBarMessage'],
                duration
              );
            }
            if (res.fieldValues['RedirectUrl']) {
              const url = res.fieldValues['RedirectUrl'];
              const currentUrl = this.router.url;
              if (`/${url}` === currentUrl && res.fieldValues['Refresh']) {
                this.invalidateSubject.invalidate('Refresh');
              } else {
                this.router.navigateByUrl(url);
              }
              return;
            }
            if (res.fieldValues['RedirectCommand']) {
              this.executeCommand(res.fieldValues['RedirectCommand']);
              return;
            }
            if (res.fieldValues['ShowFileSelector']) {
              const fileSelectorModel = new FileSelectorModel();
              fileSelectorModel.parentId = 'Team Drives';
              fileSelectorModel.isClientDrive = true;
              fileSelectorModel.iconViewModels = [];
              fileSelectorModel.fileExtensionTypes = ['.qnr'];
              fileSelectorModel.hideFiles = false;
              fileSelectorModel.skipBreadcrumbItem = false;
              fileSelectorModel.returnType = 'RelativePath';
              fileSelectorModel.foldersSelectable = false;
              this.dialogService
                .showOrbitaxDriveFileSelector(
                  fileSelectorModel,
                  res.fieldValues['FileSelectorTitle']
                )
                .pipe(take(1))
                .subscribe((state) => {
                  if (state.action === 'OK') {
                    const {name, relativePath} = state.data.input
                      .selectedItems[0] as IconViewModel;
                    const updateCommand = this.magicLinkModel
                      .additionalCommands[
                      'UpdateFieldMappingCommand'
                      ] as PlatformCommand;
                    updateCommand.fieldValues = {...res.fieldValues};
                    updateCommand.fieldValues['FileName'] = name;
                    updateCommand.fieldValues['RelativePath'] = relativePath;
                    this.executeCommandToApi(updateCommand);
                    this.resetPlatformCommandFieldValues(updateCommand, [
                      'FileName',
                      'RelativePath',
                    ]);
                  }
                });
              return;
            }
            if (res.fieldValues['Reload'] && res.fieldValues['Reload'] === true) {
              this.invalidateReferenceOptions();
            }
            this.invalidateSubject.invalidate();
          },
          (error) => {
            console.error('Failed ToolBarComponent command', error);
            this.fuseSplashScreenService.hide();
          }
        );
    }
  }

  private executeRemoveField($event: GridValueChangeEvent) {
    const command = new PlatformCommand('UpdateDataMappingFieldItemsCommand', Api.FileStoreApi);
    command.fieldValues['IsRemove'] = true;
    command.fieldValues['DataMappingFieldItemId'] = $event.item.id;
    command.fieldValues['SourceFieldDataType'] = $event.item.cells.SourceFieldDataType.value;
    command.fieldValues['SourceFieldHeader'] = $event.item.cells.Source.value;
    command.fieldValues['DataMappingItemId'] = $event.item.cells.DataMappingItemId.value;
    command.fieldValues['DestinationFieldDataType'] = $event.item.cells.DestinationFieldDataType.value;
    command.fieldValues['DestinationFieldHeader'] = $event.item.cells.Destination.value;
    command.fieldValues['FieldSectionId'] = $event.fieldSection['id'];
    command.fieldValues['IsDestinationToSource'] = $event.fieldSection['id'] == 'toggledatamappingfielditem' ? true : false;
    this.executeCommandToApi(command);
    
    this.resetPlatformCommandFieldValues(command, [
      'IsRemove',
      'DataMappingFieldItemId',
    ]);
  }

  private mapToNewField($event: GridValueChangeEvent) {
    this.dialogService
      .showTextInputDialog(
        'Map as New Field (Field Name Here)',
        '',
        '',
        50,
        'Field Name'
      )
      .pipe(take(1))
      .subscribe((payload) => {
        if (payload.action === 'OK') {
          const command = this.magicLinkModel.additionalCommands[
            'UpdateDataMappingFieldItem'
            ];
          command.fieldValues['IsNewField'] = true;
          command.fieldValues['TargetFieldHeader'] = payload.data.input.text;
          command.fieldValues['TargetFieldKey'] =
            $event.item.cells['SourceQuestionnaireField'].value;
          command.fieldValues['DataMappingFieldItemId'] = $event.item.id;
          this.executeCommandToApi(command);
          this.resetPlatformCommandFieldValues(command, [
            'IsNewField',
            'TargetFieldKey',
            'DataMappingFieldItemId',
            'TargetFieldHeader',
          ]);
        }
      });
  }

  private mapToExistingField($event: GridValueChangeEvent) {
    const command = new PlatformCommand('DataMappingDestinationSelectorTransferBoxCommand', Api.FileStoreApi);
    command.fieldValues['DataMappingFieldItemId'] = $event.item.id;
    command.fieldValues['SourceFieldDataType'] = $event.item.cells.SourceFieldDataType.value;
    command.fieldValues['SourceFieldHeader'] = $event.item.cells.Source.value;
    command.fieldValues['DataMappingItemId'] = $event.item.cells.DataMappingItemId.value;
    command.fieldValues['DestinationFieldDataType'] = $event.item.cells.DestinationFieldDataType.value;
    command.fieldValues['DestinationFieldHeader'] = $event.item.cells.Destination.value;
    command.fieldValues['FieldSectionId'] = $event.fieldSection['id'];
    command.fieldValues['IsDestinationToSource'] = $event.fieldSection['id'] == 'toggledatamappingfielditem' ? true : false;
    this.executeCommandToApi(command);
  }

  private openExistingFieldSelectorDialog(
    $event: GridValueChangeEvent,
    fieldDefinitions: any[],
    displayObjectKey: string,
    notes: string
  ) {
    const dialogModel = DialogModel.create(
      `Select Field for ${$event.item?.cells?.Source.displayText}`,
      'PlatformToolDropDownDialogComponent',
      {
        dropDownList: fieldDefinitions,
        selectedValue: fieldDefinitions[0],
        label: 'Select Field *',
        displayObjectKey: displayObjectKey ?? 'header',
        notes: notes,
        event: $event,
      },
      '400px',
      '400px'
    );

    this.dialogService
      .showOkCancelDialog(dialogModel)
      .pipe(take(1))
      .subscribe((payload) => {
        if (payload.action === 'OK') {
          const command = this.magicLinkModel.additionalCommands[
            'UpdateDataMappingFieldItem'
            ];
          command.fieldValues['IsNewField'] = false;
          command.fieldValues['TargetFieldKey'] =
            payload.data.input.selectedValue.key ??
            payload.data.input.selectedValue.fieldKey;
          command.fieldValues['DataMappingFieldItemId'] =
            payload.data.input.event.item.id;
          command.fieldValues['TargetFieldHeader'] =
            payload.data.input.selectedValue[
              dialogModel.input.displayObjectKey
              ];
          command.fieldValues['TargetDataType'] =
            payload.data.input.selectedValue.dataType;
          command.fieldValues['FieldSectionId'] = payload.data.input.event.fieldSection['id'];
          this.executeCommandToApi(command);
          this.resetPlatformCommandFieldValues(command, [
            'IsNewField',
            'TargetFieldKey',
            'DataMappingFieldItemId',
            'TargetFieldHeader',
          ]);
        }
      });
  }

  private resetPlatformCommandFieldValues(
    command: PlatformCommand,
    keys: string[]
  ) {
    keys.forEach((key) => {
      if (command.fieldValues.hasOwnProperty(key)) {
        delete command.fieldValues[key];
      }
    });
  }

  private navigateToFieldMapping(type: string) {
    const command = this.magicLinkModel.additionalCommands[
      'DataMappingManageFieldPlatformLinkCommand'
      ];
    command.fieldValues['SelectorType'] = type;
    this.executeCommandToApi(command);
    this.resetPlatformCommandFieldValues(command, ['SelectorType']);
  }

  private handleWorkflowCleanUpCommand(command: PlatformCommand) {
    const syncCommand = this.magicLinkModel.additionalCommands[
      'SyncDestinationEntities'
      ];
    if (command.fieldValues) {
      // tslint:disable-next-line:forin
      for (const key in command.fieldValues) {
        syncCommand.fieldValues[key] = command.fieldValues[key];
      }
    }
    this.executeCommandToApi(syncCommand);
  }

  private openEditor(event: GridValueChangeEvent) {
    const selectedTabModel = this.magicLinkModel.tabBar.tabs[this.magicLinkModel.tabBar.selectedIndex];
    const sourceType = selectedTabModel.tabData['SectionType'];
    this.dialogService.showCellEditorDialog(event.item, event.fieldDefinition, '800px', '1500px', sourceType)
      .subscribe(state => {
        if (state && state.action === 'OK') {
          const executionId = selectedTabModel.tabData['ExecutionId'];
          const surveyId = selectedTabModel.tabData['SurveyId'];
          console.log('After Edit', state);
          const item = {id: event.item.id, fieldValues: {}, executionId: executionId};
          item.fieldValues[event.fieldDefinition.key] = event.item.cells[event.fieldDefinition.key].value;
          // const command = new UpdateSurveyDataItemCommand(item, surveyId, executionId, executionSourceType, userId);
          // this.commandService.executeCommand(command).pipe(takeUntil(this.ngUnsubscribe)).subscribe(commandState => {
          //   console.log('Command State', commandState);
          //   this.invalidateSubject.invalidate();
          // });
        }
      });
  }
}
